export const buildExternalLandingPageUrl = (
  url: string,
  productValue: string,
  installments: string,
  upsellPaymentUrl: string,
  platformUrl: string,
  previousCartId?: string | null
) => {
  const upsellPaymentUrlWithPrevious = previousCartId
    ? `${upsellPaymentUrl}${upsellPaymentUrl.includes('?') ? '&' : '?'}previousCartId=${previousCartId}`
    : upsellPaymentUrl;

  const encodedUpsellPaymentUrl = encodeURIComponent(upsellPaymentUrlWithPrevious);
  const encodedPlatformUrl = encodeURIComponent(platformUrl);

  return `${url}?purchased-product-value=${productValue}&installments=${installments}&upsell-payment-url=${encodedUpsellPaymentUrl}&platform-url=${encodedPlatformUrl}`;
};
